'use strict'

var config, service, scontrini;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  scontrini = config.VUE_APP_MOL_S_RECEIPTS
}

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${scontrini}/cicleSync`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ multiplo })
    })
    return await response.json()
  } catch (error) {
    return null
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${scontrini}/mode`)
    const result = await response.json()
    if (result.status === 404) {
      return defaultRunMode()
    }
    return result
  } catch {
    return defaultRunMode()
  }
}

function defaultRunMode() {
  return {
    modulo: 'SCONTRINI',
    locale: '---',
    remote: '---',
    versione: '---',
    health: '---'
  }
}

async function getAllReceipts() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}`)
  return await response.json()
}

async function elencoScontriniPerData(dataDa, dataA) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    dataDa,
    dataA
  }
  const response = await fetch(`${service}/${scontrini}/data`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function nuovoScontrino() {
  if (!config || !service) {
    await getConfigFile();
  }
  console.log('[nuovoScontrino] creazione scontrino')
  const response = await fetch(`${service}/${scontrini}/create`, { method: 'POST' })
  // return await response.json()
  const json = await response.json()
  console.log('[nuovoScontrino] json:', json)
  return json
}

async function nuovoScontrinoConRighe(righe) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    righe
  }
  const response = await fetch(`${service}/${scontrini}/create`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function creaScontrinoCompleto(dati) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/create`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(dati)
  })  
  const json = await response.json()
  return json
}

async function addRigaScontrino(idScontrino, riga) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/add`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(riga)
  })
  return await response.json()
}

async function addRigheScontrino(idScontrino, righe) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/add/rows`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(righe)
  })
  return await response.json()
}

async function updateRigaScontrino(idScontrino, idRiga, riga) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/update/${idRiga}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(riga)
  })
  return await response.json()
}

async function updateRigheScontrino(idScontrino, righe) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/update/rows`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(righe)
  })
  return await response.json()
}

async function deleteRigaScontrino(idScontrino, idRiga) {
  if (!config || !service) {
    await getConfigFile();
  }
  console.log('deleteRigaScontrino', idRiga)
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/delete/${idRiga}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  return await response.json()
}

async function deleteRigaScontrinoByCode(idScontrino, codiceRiga) {
  if (!config || !service) {
    await getConfigFile();
  }
  console.log('deleteRigaScontrinoByCode', codiceRiga)
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/delete/code/${codiceRiga}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  return await response.json()
}

async function addTotaleScontrino(idScontrino, righeScontrino, infoChiusuraScontrino) {
  // in base al contenuto di infoChiusuraScontrino richiamo più volte la add riga ...

  await updateRigheScontrino(idScontrino, righeScontrino)
/*   debugger
  let rigaDaAggiungere = infoChiusuraScontrino.resto ? 4 : 2
  while (rigaDaAggiungere) {
    await addRigaScontrino(idScontrino, righeScontrino[righeScontrino.length - rigaDaAggiungere])
    rigaDaAggiungere--
  } */
}

async function cancellaScontrino(idScontrino) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  return await response.json()
}

async function aggiornaFiscaleScontrino(idScontrino, info, infoChiusura) {
  if (!config || !service) {
    await getConfigFile();
  }
  // Aggiungere anche eventuali arrotondamenti ?
  const data = {
    fiscale: info,
    pagamento: { pagamenti: infoChiusura.pagamenti, totale: infoChiusura.totale, resto: infoChiusura.resto },
    stato: infoChiusura.stato
    // statoPagamento: ....  // TODO gestire per credito o fattura ...
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/fiscale`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function getScontrino(barcode) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/barcode/${barcode}`)
  return await response.json()
}

async function getScontrinoById(id) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${id}`)
  return await response.json()
}

async function resiSuScontrino(printerResi) {
  if (!config || !service) {
    await getConfigFile();
  }
  const idScontrino = printerResi.righe[0].payload.fiscale.idScontrino // ID scontrino Origine
  var righe = printerResi.righe
  righe.forEach(riga => {
    delete riga.payload
  })
  const reso = {
    fiscale: printerResi.fiscale,
    righe
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/reso`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(reso)
  })
  return await response.json()
}

async function aggiornaAnnullamentoFiscaleSuOrigine(idScontrino, info) {
  if (!config || !service) {
    await getConfigFile();
  }
  console.log('aggiornaAnnullamentoFiscaleSuOrigine', idScontrino, info)
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/annullamento`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(info)
  })
  return await response.json()
}

// verificare prima di utilizzare... non testato
async function duplicaContenutoScontrino(idScontrino) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/duplica`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  return await response.json()
}

async function getParcheggiati() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/parking`)
  return await response.json()
}

async function updateScontrino(idScontrino, dati) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dati)
  })
  return await response.json()
}

async function updateScontrinoNoMerge(idScontrino, dati) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/noMerge`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dati)
  })
  return await response.json()
}

async function annullaParcheggio(idScontrino) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/${idScontrino}/parking/delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  return await response.json()
}

async function elencoScontriniDetraibili(filtri, parametri) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    parametri
  }
  const response = await fetch(`${service}/${scontrini}/detraibili`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function registraInvioXML(scontrini) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    scontrini
  }
  const response = await fetch(`${service}/${scontrini}/detraibili/invio`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function registraErroriInvioXML(errori) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    errori
  }
  const response = await fetch(`${service}/${scontrini}/detraibili/errori`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(data)
  })
  return await response.json()
}


async function getElencoClientiScontriniNonRiscosso(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni
  }
  try {
    const response = await fetch(`${service}/${scontrini}/documento/clienti`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

async function getElencoScontriniNonRiscosso(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni
  }
  try {
    const response = await fetch(`${service}/${scontrini}/documento`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

async function getRigheScontrino(idScontrino) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${scontrini}/documento/righe/${idScontrino}`)
  return await response.json()
}

function getScontiScontrino(r) {
  let scontoSub = 0
  let maggiorazioniSub = 0
  let locSub = 0
  let item = r.find(x => x.tipo === 'scontoSub')
  scontoSub += item ? parseFloat(item.valore) : 0
  locSub += item ? parseFloat(item.valore) : 0

  item = r.find(x => x.tipo === 'abbuonoSub')
  scontoSub += item ? parseFloat(item.valore) : 0
  locSub += item ? parseFloat(item.valore) : 0

  item = r.find(x => x.tipo === 'arrotondaDifetto')
  scontoSub += item ? -parseFloat(item.valore) : 0
  locSub += item ? parseFloat(item.valore) : 0

  item = r.find(x => x.tipo === 'arrotondaEccesso')
  maggiorazioniSub += item ? parseFloat(item.valore) : 0
  locSub += item ? parseFloat(item.valore) : 0

  item = r.find(x => x.tipo === 'subtotale')
  let subtotale = item ? parseFloat(item.prezzo) : 0
  if (subtotale === 0 && locSub !== 0) {
    subtotale = getTotaleProdotti(r).totale
  }
  const abbuonoPerEuro = subtotale > 0 ? (locSub) / subtotale : 0
  return {scontoSub, maggiorazioniSub, abbuonoPerEuro, subtotale}
}

async function scambioDatiMarcaTrasferiti(codiceModello, ids) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    ids,
    codiceModello
  }
  try {
    const response = await fetch(`${service}/${scontrini}/trasferiti`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

async function scontriniDaProforma(idProforma) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    idProforma
  }
  try {
    const response = await fetch(`${service}/${scontrini}/scontriniDaProforma`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

export default {
  cicleSync,
  getRunMode,
  getAllReceipts,
  elencoScontriniPerData,
  addRigaScontrino,
  addRigheScontrino,
  updateScontrino,
  updateScontrinoNoMerge,
  updateRigaScontrino,
  updateRigheScontrino,
  deleteRigaScontrino,
  deleteRigaScontrinoByCode,
  addTotaleScontrino,
  nuovoScontrino,
  cancellaScontrino,
  aggiornaFiscaleScontrino,
  getScontrino,
  getScontrinoById,
  resiSuScontrino,
  aggiornaAnnullamentoFiscaleSuOrigine,
  duplicaContenutoScontrino,
  nuovoScontrinoConRighe,
  creaScontrinoCompleto,
  getParcheggiati,
  annullaParcheggio,
  elencoScontriniDetraibili,
  registraInvioXML,
  registraErroriInvioXML,
  getElencoClientiScontriniNonRiscosso,
  getElencoScontriniNonRiscosso,
  getRigheScontrino,
  getScontiScontrino,
  scambioDatiMarcaTrasferiti,
  scontriniDaProforma
}
